import { TFullName } from "./nameLiterals";

export const isAFullName = (text: unknown): text is TFullName =>
    typeof text === "string" 
    && text.match(/[A-Za-z]+(\s|\.)[A-Za-z]+/) !== null
;